export function getDateFromZulu(dateString) {
  if(dateString === null ) {return "-"}
  let dateTime = "";
  const date = new Date(dateString);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  dateTime += months[date.getMonth()];
  let newDate = date.getDate().toString();
  if (newDate.length < 2) {
    newDate = "0" + newDate;
  }
  dateTime += " " + newDate;
  dateTime += " " + date.getFullYear();
  let hours = date.getHours();
  let dayTime = "";
  if (hours === 0) {
    hours = "12";
    dayTime = "AM";
  } else if (hours === 12) {
    hours = "12";
    dayTime = "PM";
  } else if (hours < 12) {
    hours = hours.toString();
    dayTime = "AM";
  } else {
    hours -= 12;
    hours = hours.toString();
    dayTime = "PM";
  }
  dateTime += " " + hours;
  let minutes = date.getMinutes().toString();
  if (minutes.length < 2) {
    minutes = "0" + minutes;
  }
  dateTime += ":" + minutes;
  dateTime += " " + dayTime;
  return dateTime;
}
